export const SET_LOADING_SPINNER_PROGRESS = 'GIFTYA/SET_LOADING_SPINNER_PROGRESS';
export const SET_LOADING_SPINNER_OPEN = 'GIFTYA/SET_LOADING_SPINNER_OPEN';
export const SET_LOADING_SPINNER_TYPE = 'GIFTYA/SET_LOADING_SPINNER_TYPE';
export const SET_LOADING_SPINNER_MESSAGE = 'GIFTYA/SET_LOADING_SPINNER_MESSAGE';


export const setLoadingSpinnerProgress = (percent) => ({
    type: SET_LOADING_SPINNER_PROGRESS,
    percent
});

export const setLoadingSpinnerOpen = (open) => ({
    type: SET_LOADING_SPINNER_OPEN,
    open
});

export const setLoadingSpinnerType = (spinnerType) => ({
    type: SET_LOADING_SPINNER_TYPE,
    spinnerType
});

export const setLoadingSpinnerMessage = (spinnerMessage) => ({
    type: SET_LOADING_SPINNER_MESSAGE,
    spinnerMessage
});